export const toggleSidebar = (data) => async (dispatch) => {

    dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: data,
    });
}